<template>
    <div class="col-12">
        <Card class="bloc-card">
            <template #header>
                <div class="flex w-100 bg-primary-sliced p-2">
                    <span class="bloc-index">{{ index + 1 }}</span>
                    <as-title class="title color-white pl-5" :title="sujet.sujet" :size="4" />
                    <div class="flex align-items-center ml-auto">
                        <Chip v-if="sujet.mustRead" :label="$t('rituals.ritual_details.ritual_bloc_must_read_label')"
                            class="must-read bg-error pl-3 pr-3" />
                    </div>
                </div>
            </template>

            <template #content class="p-0">
                <div class="grid">
                    <div class="col-8">
                        <as-title class="title mb-2" :title="$t('rituals.ritual_details.note_label')" :size="4" />
                        <div v-html="sujet.note" class="tinymce-content w-100 note p-3"></div>
                    </div>

                    <div v-if="sujet.fichiers.length" class="col-4">
                        <as-title class="title mb-2" :title="$t('rituals.ritual_details.file_label')" :size="4" />
                        <div class="flex improvement grid">
                            <as-file v-for="fichier in sujet.fichiers" :key="fichier.id"
                                class="col-12 header-file__content" :fichier="fichier"
                                @onDownload="$emit('download', fichier.externalId, fichier.titre)" />
                        </div>
                    </div>
                </div>
            </template>
        </Card>
    </div>
</template>

<script>
import Card from 'primevue/card';
import AsTitle from '../Elements/AsTitle.vue';
import AsFile from '../Elements/AsFile.vue';
import Chip from 'primevue/chip';

export default {
    name: "RitualDetailsSubject",
    components: {
        AsTitle,
        AsFile,
        Card,
        Chip,
    },
    props: {
        sujet: {
            type: Object,
            required: true
        },
        index: {
            type: Number,
            required: true
        }
    }
};
</script>
